/**
 * @desc 按照品种code分组查询所有指数列表
 */
import {
  PriceIndexGroupKindCodeDto,
  PriceIndexGroupKindCodeQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPriceIndexListGroupKindCodeParameter =
  PriceIndexGroupKindCodeQuery

const method = 'GET'
const url = '/content/mall/priceIndex/groupKindCode/list'

export const queryPriceIndexListGroupKindCodeApi = (
  params?: QueryPriceIndexListGroupKindCodeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<PriceIndexGroupKindCodeDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryPriceIndexListGroupKindCodeApi.method = method
queryPriceIndexListGroupKindCodeApi.url = url
